import { URI_FINANCIAL_ACCOUNT } from '@/config/config';

export default async ({ rootState }, { range, selectedAccount }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  let path = `${URI_FINANCIAL_ACCOUNT}account-movements/predict/${selectedAccount}`;
  if (range) {
    const query = Object.keys(range)
      .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(range[k])}`)
      .join('&');

    path += `?${query}`;
  }

  const response = await fetch(path, opts);

  const jsonResult = await response.json();

  if (jsonResult.status === 'error') {
    return Promise.reject(jsonResult.message);
  }
  return jsonResult.data;
};
